export default class Widget {

    static connect( roomId, token ) {
        document.querySelector('#ciscowidget').style.display = 'block';

        window.ciscospark.widget(document.getElementById('ciscowidget'))
            .spaceWidget({
                guestToken: token,
                destinationType: 'spaceId',
                destinationId: roomId
            });
    }
}